import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { CashierBase } from '../../cashier-base/cashier-base';
import { DepositMainLabels } from '../cashier-models/interfaces';
import { NeoSurfModel } from '../cashier-models/models';

@Component({
  selector: 'app-deposit-neosurf',
  templateUrl: './deposit-neosurf.component.html',
  styleUrls: ['./deposit-neosurf.component.scss'],
})

export class DepositNeosurfComponent extends CashierBase implements OnInit {

  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() public navigateBackPage: any;

  public depositForm: FormGroup;

  public bonusCode: string;
  public defaultAmounts: any = [];
  public buttonDisabled: boolean = false;
  public error: any;
  public labels: any;
  public minAmount: any;
  public paymentType: any = [];
  public transactionID: any;

  constructor(
    private formBuilder: FormBuilder,
    readonly appLinks: AppLinksService,
    readonly cashierService: CashierService,
    readonly cashierContentService: CashierContentService,
    readonly navigator: Navigator,
    readonly successMessageService: SuccessMessageService,
  ) {
    super();

    this.labels = new NeoSurfModel();
  }

  ngOnInit(): void {
    this.depositForm = this.formBuilder.group({
      amount: ['', Validators.required]
    });
  }

  ngAfterViewInit() {
    this.cashierContentService.getPageConfig('neosurf').then((response: DepositMainLabels) => {
      this.labels = response;
    });
  }

  ionViewDidEnter() {
    this.successMessageService.clearMessage();
    this.cashierService.getActivePaymentTypes('NS').subscribe((response: any) => {
      if (response.result) {
        this.paymentType = response.payload;
        this.minAmount = this.paymentType[0].min;
        this.defaultAmounts = this.cashierContentService.getDefaultPayments(this.paymentType, 0);
      }
    }, (error) => console.error("Type category error", error));
  }

  protected onAmountSelected(amount): any {
    return this.depositForm.get('amount').setValue(amount);
  }

  protected onSubmit(): void {

    this.buttonDisabled = true;
    this.successMessageService.clearMessage();
    this.error = null;

    const amount = this.depositForm.get('amount').value;

    const obj: any = {};
    obj.amount = amount;
    obj.bonusCode = this.bonusCode;
    obj.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
    obj.payment_type_code = "NS";

    this.cashierService.callDeposit(obj).subscribe((response: any) => {
      if (response?.result === 1) {
        const payload = response?.payload;
        this.transactionID = payload?.paymentRequestID;
        this.continueNeosurf(response, amount);
      }
    }, error => {
      this.error = error;
      this.buttonDisabled = false;
      this.content?.scrollToTop(10);
    });
  }

  protected selectedDepositBonusOffer($event): void {
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  private continueNeosurf(data: any, amount: any): any {
    const obj: any = {}
    obj.amount = amount;
    obj.merchantTransactionId = this.transactionID;
    obj.currencyCode = this.cashierService.customer.preferredCurrency.currencyCode;

    return this.navigator.navigateTo("DepositNeosurfActionComponent", { multipleModals: true }, { neosurfData: obj })
  }

  protected goToLink(link: string): any {
    return this.appLinks.openExternalPage(link);
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

}
